import styled from "styled-components";

export const LoginPageWrapper = styled.section`
  width: 100%;
  height: 100%;
  padding: 20rem 0;
`;

export const LoginInfoWrapper = styled.div`
  margin: 2rem;
  padding: 2rem;
  text-align: center;
`;

export const LoginTitle = styled.h1`
  font-size: 4.6rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

export const LoginDescription = styled.p`
  font-size: 2rem;
  padding: 1rem;
  margin-bottom: 1rem;
`;

export const LoginWarningMessage = styled.p`
  font-size: 1.6rem;
  line-height: 1.4;
`;

// 버튼은 재사용 컴포넌트로 따로 만들어야겠다.
export const LoginButton = styled.button`
  margin: 1.5rem auto;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 20rem;
  height: 5rem;
  font-size: 1.8rem;
  background-color: transparent;
  outline: none;
  border: 1px solid black;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    color: rgb(177, 177, 177);
    border: 1px solid rgb(177, 177, 177);
  }
`;
